import React, { useState, useEffect } from 'react';
import { axiosInstance } from '@/App';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

export default function SourceView() {
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get('/views/source', { params: { date } });
      setData(response.data);
    } catch (error) {
      toast.error('Failed to load source view');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [date]);

  return (
    <div data-testid="source-view-page">
      <div className="page-header">
        <h1 className="page-title">Source View</h1>
        <p className="page-subtitle">Performance breakdown by lead source</p>
      </div>

      <Card className="mb-8 p-6">
        <div className="flex gap-4 items-end">
          <div className="space-y-2 w-64">
            <Label>Date</Label>
            <Input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              data-testid="date-input"
            />
          </div>
        </div>
      </Card>

      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="loading-spinner" />
        </div>
      ) : (
        <div className="data-table">
          <table>
            <thead>
              <tr>
                <th>Source Type</th>
                <th>Dialed</th>
                <th>Connected</th>
                <th>Connect %</th>
                <th>Scheduled</th>
                <th>Done</th>
                <th>Closures</th>
              </tr>
            </thead>
            <tbody>
              {data.map((source, idx) => (
                <tr key={idx} data-testid={`source-row-${idx}`}>
                  <td className="font-semibold">{source.source}</td>
                  <td>{source.dialed}</td>
                  <td>{source.connected}</td>
                  <td>
                    <span style={{ color: source.connect_pct >= 70 ? '#16a34a' : source.connect_pct >= 60 ? '#f59e0b' : '#dc2626' }}>
                      {source.connect_pct}%
                    </span>
                  </td>
                  <td>{source.scheduled}</td>
                  <td>{source.done}</td>
                  <td className="font-semibold">{source.closures}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
